module.exports = __webpack_public_path__ + "img/basics-goods-hei.65958fae.svg";